<template>
  <div class="foot">
    <span class="text">ICP for 05052060</span>
  </div>
</template>

<script>
export default {
  name: 'bottom-text',
}
</script>


<style lang="less" scoped>
  .foot {
    width: 100%;
    height: 40px;
    line-height: 40px;
    position: relative;
    bottom: 0;
    background-image: linear-gradient(180deg, #090d17 0%, #0d111a 100%);
    // background-image: linear-gradient(10deg, #AB258B 0%, #7B44EA 100%);
    // background-image: linear-gradient(-90deg, #4A2C82 0%, #432D8C 50%, #35237D 100%);
    color: white;
    font-size: 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    letter-spacing: 0;

    .text {
      opacity: 0.7;
    }
  }
</style>



// WEBPACK FOOTER //
// bottom-text.vue?cc047e14